import React, {useEffect, useState} from "react";
import Table from "../../../components/Table/Table";
import './AdministrativeComponents.css'
import {Bounce, toast} from "react-toastify";
import SearchTicketModal from "../../../components/SearchTicketModal/SearchTicketModal";
import {useGetComponents} from "../../../hooks/Administrative/useGetComponents";
import {useAddComponent} from "../../../hooks/Administrative/useAddComponent";
import {useUpdateComponent} from "../../../hooks/Administrative/useUpdateComponent";
import {useGetComponentById} from "../../../hooks/Administrative/useGetComponentById";
import FilterComponentsModal from "../../../components/FilterComponentsModal/FilterComponentsModal";

const columns = ["NOMBRE", "TIPO", "CLAVE", "ESTADO"];

const typeOptions = [
    {value: '', label: 'Seleccione un tipo'},
    {value: 'CONTROLLER', label: 'Controlador'},
    {value: 'TANK', label: 'Tanque'},
    {value: 'DISPENSER', label: 'Dosificador'},
    {value: 'AGITATOR', label: 'Agitador'}
];

const stateOptions = [
    {value: 'AVAILABLE', label: 'Disponible'},
    {value: 'IN_USE', label: 'En Uso'},
    {value: 'BLOCKED', label: 'Bloqueado'}
];

const AdministrativeComponents = () => {

    const [filters, setFilters] = useState({});

    const clearFilters = () => setFilters({});

    const {
        components,
        totalPages,
        isLoading,
        page,
        setPage,
        addComponentLocally,
        updateComponentLocally
    } = useGetComponents({
        filters,
        clearFilters
    });

    const handleFilterModal = (newFilters: object) => {
        setFilters(newFilters);
        setPage(0);
    };

    const [showAddComponent, setShowAddComponent] = useState(false);
    const [isConfirmDisabled, setIsConfirmDisabled] = useState(true);

    const [newComponentName, setNewComponentName] = useState("");
    const [newComponentUniqueCode, setNewComponentUniqueCode] = useState("");
    const [newComponentType, setNewComponentType] = useState("");

    const {addComponent, saving} = useAddComponent();
    const [isSearchModalVisible, setSearchModalVisible] = useState(false);
    const [isFilterModalVisible, setFilterModalVisible] = useState(false);

    const [showEditComponent, setShowEditComponent] = useState(false);

    const {component, fetchComponentById} = useGetComponentById()
    const [editDisabled, setEditDisabled] = useState(true);

    const [localComponentName, setLocalComponentName] = useState("");
    const [localComponentUniqueCode, setLocalComponentUniqueCode] = useState("");
    const [localComponentState, setLocalComponentState] = useState("");
    const [localComponentType, setLocalComponentType] = useState("");

    const {updateExistingComponent, updatingComponent} = useUpdateComponent();

    useEffect(() => {
        if (component) {
            setLocalComponentName(component.name);
            setLocalComponentUniqueCode(component.uniqueCode);
            setLocalComponentType(component.type);
            setLocalComponentState(component.state);
        }
    }, [component]);


    useEffect(() => {
        let isDisabled;
        if (newComponentType === 'DISPENSER') {
            isDisabled = !newComponentUniqueCode || !newComponentType;
        } else {
            isDisabled = !newComponentName || !newComponentUniqueCode || !newComponentType;
        }

        setIsConfirmDisabled(isDisabled);
    }, [newComponentName, newComponentUniqueCode, newComponentType]);

    const handleAddComponent = () => {
        setShowEditComponent(false);
        setShowAddComponent(true);
    }

    const clearFields = () => {
        setNewComponentName("");
        setNewComponentUniqueCode("");
        setNewComponentType("");
    }

    const handleSearchModal = (uniqueCode: string) => {
        setFilters({uniqueCode});
    };

    const handleCloseFilterModal = () => {
        setFilterModalVisible(false);
    }

    const handleResetClientsTable = () => {
        setFilters({});
        setPage(0);
        setEditDisabled(true);
        setShowAddComponent(false);
        setShowEditComponent(false);
    };

    const handleOnRowClick = (row: Record<string, any>) => {
        setShowAddComponent(false);
        setShowEditComponent(true);
        fetchComponentById(row.ID);
    };

    const validateField = (field: any, regex: any, errorMessage: any) => {
        if (!regex.test(field)) {
            toast.error(errorMessage, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return false;
        }
        return true;
    };

    const handleUpdate = () => {

        if (!validateField(localComponentUniqueCode, /^[a-zA-Z0-9_]{5,90}$/, "El código único solo puede contener letras, " +
            "números y guión bajo (_). Tiene que tener entre 5 y 90 caracteres.")) return;
        if (!validateField(localComponentName, /^.{1,60}$/, "El nombre del componente no puede exceder los 60 caracteres ni estar vacío.")) return;

        const updatedComponent = {
            name: localComponentName,
            type: localComponentType,
            uniqueCode: localComponentUniqueCode,
            state: localComponentState,
            id: component.id
        }

        updateExistingComponent(updatedComponent, component.id).then(response => {
            toast.success('¡Componente actualizado correctamente!', {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });

            if(updatedComponent.type === 'DISPENSER'){
                updatedComponent.name = updatedComponent.uniqueCode;
            }

            updateComponentLocally(component.id, updatedComponent);
            setShowEditComponent(false);
            setEditDisabled(true);

        }).catch(error => {
            toast.error("Error al actualizar componente", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
        })

    }

    const handleNewComponent = (e: React.FormEvent) => {
        e.preventDefault();

        if (newComponentType !== 'DISPENSER') {
            if (!validateField(newComponentName, /^.{1,60}$/, "El nombre del componente no puede exceder los 60 caracteres ni estar vacío.")) return;
        }
        if (!validateField(newComponentUniqueCode, /^[a-zA-Z0-9_]{5,90}$/, "El código único solo puede contener letras, " +
            "números y guión bajo (_). Tiene que tener entre 5 y 90 caracteres.")) return;

        const newComponent = {
            name: newComponentName,
            type: newComponentType,
            uniqueCode: newComponentUniqueCode,
        }

        addComponent(newComponent).then((response: any) => {
                toast.success('¡Componente creado correctamente!', {
                    position: 'top-right',
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    theme: 'colored',
                    transition: Bounce,
                });
                addComponentLocally(response);
                clearFields()
            }
        ).catch((err: any) => {
            toast.error(err, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
        })
    }

    return (
        <div className="additive-view-container">
            <div className="additive-view-left">
                <div className="additive-view-header">
                    <div className="additive-view-header-title">
                        <p>COMPONENTES</p>
                    </div>
                    <span className="material-icons-outlined icon-unselected" onClick={handleAddComponent}>
                        add_box
                </span>
                    <span className="material-icons-outlined icon-unselected"
                          onClick={() => setFilterModalVisible(true)}>
                        filter_alt
                </span>
                    <span className="material-icons-outlined icon-unselected" onClick={() => {
                        setSearchModalVisible(true)
                    }}>
                    search
                </span>
                    <span className="material-icons-outlined icon-unselected" onClick={handleResetClientsTable}>
                    restart_alt
                </span>
                </div>
                {isLoading ?
                    (
                        <div className="loading-overlay">
                            <div className="spinner"></div>
                            <div className="loading-message">Obteniendo información...</div>
                        </div>
                    ) : (
                        <div className="additive-table-container">
                            <Table
                                columns={columns}
                                data={components}
                                totalPages={totalPages}
                                currentPage={page}
                                setCurrentPage={setPage}
                                onRowClick={handleOnRowClick}
                            />
                        </div>
                    )}
            </div>
            <div className="add-additive">
                {showAddComponent && (
                    <div className="additive-actions-container">
                        <div className="additives-view-actions-wrapper">
                            {saving ?
                                (
                                    <div className="loading-overlay-for-additive-view">
                                        <div className="spinner"></div>
                                        <div className="loading-message">Guardando</div>
                                    </div>
                                ) :
                                (
                                    <div>
                                        <div className="additive-view-header">
                                            <div className="additive-view-header-title">
                                                <p>AÑADIR COMPONENTE</p>
                                            </div>
                                        </div>
                                        <div className="select-component-type">
                                            <label htmlFor="type">TIPO *</label>
                                            <select
                                                id="type"
                                                value={newComponentType}
                                                onChange={(e) => {
                                                    setNewComponentName("")
                                                    setNewComponentType(e.target.value)
                                                    setNewComponentUniqueCode("")
                                                }}
                                            >
                                                {typeOptions.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        {newComponentType && (
                                            <form className="add-additive-form" onSubmit={handleNewComponent}>
                                                {newComponentType !== "DISPENSER" && (
                                                    <div className="form-item">
                                                        <label htmlFor="name">NOMBRE *</label>
                                                        <input
                                                            id="name"
                                                            value={newComponentName}
                                                            onChange={(e) => setNewComponentName(e.target.value)}
                                                        />
                                                    </div>
                                                )}
                                                <div className="form-item">
                                                    <label htmlFor="uniqueCode">
                                                        {newComponentType === "DISPENSER" ? "No. DE SERIE" : "CÓDIGO ÚNICO"}
                                                    </label>
                                                    <input
                                                        id="uniqueCode"
                                                        value={newComponentUniqueCode}
                                                        onChange={(e) => setNewComponentUniqueCode(e.target.value)}
                                                    />
                                                </div>
                                                <div className="bottom">
                                                    <p>* Campos obligatorios</p>
                                                    <div className="buttons">
                                                        <button type="button" className="cancel" onClick={clearFields}>
                                                            Cancelar
                                                        </button>
                                                        <button
                                                            type="submit"
                                                            className={`confirm ${isConfirmDisabled ? "disabled" : ""}`}
                                                            disabled={isConfirmDisabled}
                                                        >
                                                            Guardar
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        )}
                                    </div>
                                )
                            }
                        </div>
                    </div>
                )}

                {updatingComponent ? (
                    <div className="loading-overlay-for-additive-view">
                        <div className="spinner"></div>
                        <div className="loading-message">Guardando</div>
                    </div>) : (
                    <div>
                        {showEditComponent && (
                            <div>
                                <div className="plants-info-view-header">
                                    <div className="plants-info-view-header-title">
                                        <p>COMPONENTE</p>
                                    </div>
                                    <span
                                        className={`material-icons-outlined icon-unselected ${
                                            !editDisabled ? "active-edit" : ""
                                        }`}
                                        onClick={() => setEditDisabled(!editDisabled)}
                                    >
                                edit
                            </span>
                                </div>
                                <div className="plants-info-fields">
                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">{localComponentType !== "DISPENSER" ? "CLAVE ÚNICA" : "No. DE SERIE"}</div>
                                        {localComponentType !== "DISPENSER" ? (
                                                <div className="value-label">{localComponentUniqueCode}</div>) :
                                            (<input
                                                className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                                type="text"
                                                value={localComponentUniqueCode}
                                                disabled={editDisabled}
                                                onChange={(e) => setLocalComponentUniqueCode(e.target.value)}
                                            />)}

                                    </div>

                                    {localComponentType !== "DISPENSER" && (
                                        <div className="client-info-attribute">
                                            <div className="client-attribute-label">NOMBRE</div>
                                            <input
                                                className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                                type="text"
                                                value={localComponentName}
                                                disabled={editDisabled}
                                                onChange={(e) => setLocalComponentName(e.target.value)}
                                            />
                                        </div>
                                    )}

                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">TIPO</div>
                                        <div className={`value-label ${editDisabled ? "input-disabled" : ""}`}>
                                            {typeOptions.find(option => option.value === localComponentType)?.label || ""}
                                        </div>
                                    </div>

                                    {/* Estado (Always Shown) */}
                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">ESTADO</div>
                                        <input
                                            className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                            type="text"
                                            value={stateOptions.find(option => option.value === localComponentState)?.label}
                                            disabled={true}
                                        />
                                    </div>

                                    {/* Bottom Buttons (Only shown when not in editDisabled mode) */}
                                    {!editDisabled && (
                                        <div className="bottom-buttons">
                                            <button type="submit" className="confirm" onClick={handleUpdate}>
                                                Guardar
                                            </button>
                                        </div>
                                    )}
                                </div>

                            </div>
                        )}
                    </div>
                )}

                <FilterComponentsModal
                    isVisible={isFilterModalVisible}
                    onClose={handleCloseFilterModal}
                    onSearch={handleFilterModal}
                    types={typeOptions}
                    states={stateOptions}/>

                <SearchTicketModal
                    isVisible={isSearchModalVisible}
                    onClose={() => setSearchModalVisible(false)}
                    onSearch={handleSearchModal}
                    placeholder="Clave de componente"
                />
            </div>
        </div>
    )
}

export default AdministrativeComponents;